import {Button} from '@/components/ui/button/Button'
import {useAgendaNavigation} from '@/features/agenda/hooks/useAgendaNavigation'
import {AgendaEventType} from '@/features/agenda/types'
import {useTranslation} from '@/translations/i18n'
import dayjs from 'dayjs'
import {ShowMoreProps} from 'react-big-calendar'

export const AgendaCalendarShowMoreEvents = ({event}: {event: ShowMoreProps<AgendaEventType>}) => {
    const {t} = useTranslation()
    const {navigateWithParams} = useAgendaNavigation()

    return (
        <Button
            variant="ghost"
            size="xs"
            onClick={() => navigateWithParams({view: 'day', date: dayjs(event.slotDate).format('DD-MM-YYYY')})}
        >
            {t('agenda:show_more', {count: event.count})}
        </Button>
    )
}
